// Approved IWOptimizeMe imagery, served locally. Sources: memory/IMAGE_SOURCES.md.
export const brandImages = {
  box: {
    src: '/images/kit-box-480.webp',
    srcSet: '/images/kit-box-160.webp 160w, /images/kit-box-320.webp 320w, /images/kit-box-480.webp 480w, /images/kit-box-640.webp 640w',
    sizes: '(max-width: 639px) 96px, (max-width: 1023px) 180px, 220px',
    alt: 'Integrated Wellness at-home blood test box with the full logo',
    width: 912,
    height: 1157,
  },
  kit: {
    src: '/images/iwoptimizeme/full-kit.webp',
    alt: 'Integrated Wellness kit box with the full logo beside the RedDrop One collection device',
    width: 1180,
    height: 820,
  },
  collection: {
    src: '/images/iwoptimizeme/collection-device.webp',
    alt: 'Close-up of the RedDrop One collection device and sample tube',
    width: 1288,
    height: 896,
  },
  progress: {
    src: '/images/iwoptimizeme/wellness-wearable.webp',
    alt: 'Wearable showing heart-rate and recovery readings for ongoing wellness tracking',
    width: 900,
    height: 900,
  },
};